module.exports = __webpack_public_path__ + "img/43.8573078c.png";